import {DownOutlined, UserOutlined} from '@ant-design/icons';
import {Button, Drawer, Dropdown, Space, Avatar, Popover} from 'antd';
import React, {useState, useEffect, useContext} from 'react';
import './Navbar.css';
import {useNavigate, Link} from "react-router-dom";
import {ReactComponent as Notification} from '../../assets/navbar/notification.svg';
import {ReactComponent as Message} from '../../assets/navbar/sms.svg';
import Logo from "../../assets/navbar/logo.png"
import {getNotifications} from "./api/apis";
import {SocketContext} from "../../SocketContext";

const Navbar = () => {
    const [state, setState] = useState({
        selectedTab: "/",
        openDrawer: false,
        notificationsList: []
    })

    const [isScrolled, setIsScrolled] = useState(false);

    const [language, setLanguage] = useState('English');

    const navigate = useNavigate()

    let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");

    const pathname = window.location.pathname

    let menu = [
        {
            title: 'Home',
            route: "/"
        },
        {
            title: 'About Us',
            route: "/aboutus"
        },
        ...(isLoggedIn ? [{
            title: 'Home Tour Requests',
            route: "/homeTourRequest"
        },
            {
                title: 'Recent Views',
                route: "/recentViews"
            }] : [])
    ];

    const handleMenuClick = (e) => {
        const selectedLanguage = e.key === '0' ? 'English' : 'Spanish';
        setLanguage(selectedLanguage);
        // You could also add logic to change the app language here
    };

    const languageMenu = [
        {
            label: "English",
            key: '0',
        },
        {
            label: "Spanish",
            key: '1',
        }
    ];

    const items = [
        ...(isLoggedIn ? [{
            label: <Link to="/settings">Settings</Link>,
            key: '0',
        }] : []),

        ...(isLoggedIn ? [{
            label: <Link to="/savedProperties">Saved Properties</Link>,
            key: "1",
        }] : []),

        {
            label: isLoggedIn
                ? <Link to="/login" onClick={() => {
                    localStorage.removeItem("token")
                    localStorage.removeItem("userLogin")
                    localStorage.removeItem("user")
                    localStorage.removeItem("userId")
                    localStorage.removeItem("loginUserData")
                }}>Logout</Link>
                : <Link to="/login">Login</Link>,
            key: '2',
        },
        {
            label: !isLoggedIn && <Link to="/signup">Signup</Link>,
            key: '3',
        }
    ].filter(Boolean);

    const menuItems = () => {

        return menu.map((item, idx) => {
               return  <p key={idx} onClick={() => {
                    setState({...state, selectedTab: item.route, openDrawer: false})
                    navigate(item.route)
                }}
                   style={{
                       color: "black",
                       fontWeight: item.route === pathname && 550
                   }}
                >{item.title}</p>
            }
        )
    }


    useEffect(() => {
        setState((prevState) => {
            if (prevState.selectedTab !== pathname) {
                return {...prevState, selectedTab: pathname};
            }
            return prevState;
        });
    }, [pathname]);

    useEffect(() => {

        getNotifications().then((res) => {
            setState({
                ...state,
                notificationsList: res
            })
        })

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const socket = useContext(SocketContext);

    useEffect(() => {
        if (!socket) return;

        socket.on('notification', (newMessage) => {
            setState((prevState) => ({
                ...prevState,
                notificationsList: [...prevState.notificationsList, newMessage]
            }));
            console.log("New notification received:", newMessage);
        });

        return () => {
            socket.off('message');
        };
    }, [socket]);

    const userNotifications = (
        <div style={{padding: '10px', maxHeight: "200px", overflow: "auto"}}>
            {
                state.notificationsList.length > 0 ?
                    state.notificationsList.map((item, index) => {
                        return <div
                            style={{
                                padding: "10px",
                                borderBottom: "1px solid #ddd",
                            }}
                        >
                            <b>
                                {item?.payload?.message?.length > 10
                                    ? item.payload.message.slice(0, 10) + "..."
                                    : item.payload.message}
                            </b>
                            <br/>
                            {item.message}
                        </div>

                    })

                    :
                    <p>No Notification Yet.....</p>
            }

        </div>
    );

    let loginInfo = !!localStorage.getItem("loginUserData") && JSON.parse(localStorage.getItem("loginUserData"))

    return <div className={'navbarContainer'} style={{
        backdropFilter: isScrolled ? 'blur(8px)' : 'none',
        background: "white"
    }}>
        <div className={"navbar"}>
            <h3 style={{
                cursor: "pointer",
            }}>
                <img onClick={() => setState({
                    ...state,
                    openDrawer: true
                })} className={"menuLogo"} src={ Logo } alt={"logo"} style={{
                    height: 36
                }}/>
                <span className={"logoName"} onClick={() => navigate("/")}><img src={Logo} alt={"logo"} style={{
                    height: 36
                }}/>  Rentary</span></h3>
            <div className={"menuContainer"}>
                {
                    menuItems()
                }
                {/*<Dropdown*/}
                {/*    menu={{items: languageMenu, onClick: handleMenuClick}}*/}
                {/*>*/}
                {/*    <Button onClick={(e) => e.preventDefault()}>*/}
                {/*        <Space>*/}
                {/*            {language}*/}
                {/*            <DownOutlined/>*/}
                {/*        </Space>*/}
                {/*    </Button>*/}
                {/*</Dropdown>*/}
                <div style={{
                    display: "flex",
                    gap: 18,
                    alignItems: "center"
                }}>
                    {isLoggedIn && <Message onClick={() => navigate("/conversation")}/>}
                    {isLoggedIn && <Popover content={userNotifications} title="Notifications">
                        <Notification/>
                    </Popover>}

                    <Dropdown
                        menu={{
                            items,
                        }}
                    >
                        <Space>
                            <Avatar src={!!loginInfo && loginInfo.photo } icon={<UserOutlined/>}/>
                        </Space>
                    </Dropdown>
                </div>
                <Drawer
                    title="Rentary"
                    placement={"left"}
                    closable={false}
                    onClose={() => {
                        setState({...state, openDrawer: false})
                    }}
                    open={state.openDrawer}
                    key={"left"}
                >
                    <div className={"drawerContainer"}>
                        <div className={"menuContainer"}
                             style={{
                                 display: "block"
                             }}
                        >
                            {
                                menuItems("inDrawer")
                            }
                        </div>
                    </div>
                </Drawer>
            </div>
        </div>
    </div>
}

export default Navbar